import React from 'react';
import { Helmet } from 'react-helmet';

const Seo = ({
  title = 'Uniofunds',
  description = 'Uniofunds empowering communities through financial collaboration and inclusion',
  canonical,
  image,
}) => {
  const siteUrl = 'https://www.uniofunds.com';
  const canonicalUrl = canonical || siteUrl;
  const ogImage = image || `${siteUrl}/favicon.ico`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default Seo;
